// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationItem-root-2-Q5Q","anchor":"NavigationItem-anchor-apLK_","active":"NavigationItem-active-3LDRS"};